<script lang="ts">
	import Container from '$lib/layout/container.svelte';

	let { data, children } = $props();
</script>

<svelte:head>
	<title>{data.content.seoTitle || ''}</title>
	<meta name="description" content={data.content.seoDescription || ''} />
</svelte:head>

<section class="bg-white py-8 lg:py-12">
	<Container>
		<div
			class="flex flex-col text-left transition-padding duration-300 ease-out"
			style="padding-top: var(--full-header-height)"
		>
			{#if data.content.headline}
				<h1
					class="mb-6 text-[48px] font-semibold leading-none text-brown-1 lg:mb-12 2xl:text-[64px]"
				>
					{data.content.headline}
				</h1>
			{/if}

			{@render children?.()}
		</div>
	</Container>
</section>
